export interface PageAccessState {
  isAdmin: boolean;
  assignedTasksOnly: boolean;
  canViewDashboard: boolean;
  canViewTeam: boolean;
  canViewReports: boolean;
}

const RESTRICTED_PRIMARY_PATHS = new Set(['/dashboard', '/team', '/reports']);

export function canAccessPage(path: string, state: PageAccessState): boolean {
  if (state.isAdmin) return true;
  if (state.assignedTasksOnly && RESTRICTED_PRIMARY_PATHS.has(path)) return false;

  switch (path) {
    case '/home':
      return true;
    case '/dashboard':
      return state.canViewDashboard;
    case '/team':
      return state.canViewTeam;
    case '/reports':
      return state.canViewReports;
    default:
      return true;
  }
}

export function isMainNavItemVisible(path: string, state: PageAccessState): boolean {
  return canAccessPage(path, state);
}

export function getDefaultAuthenticatedPath(_state: PageAccessState): string {
  return '/home';
}
